module.exports = __webpack_public_path__ + "assets/img/banner1.b71f7285.png";